import { render, staticRenderFns } from "./ShareKaKaoComponent.vue?vue&type=template&id=3928cafa&scoped=true"
import script from "./ShareKaKaoComponent.vue?vue&type=script&lang=js"
export * from "./ShareKaKaoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3928cafa",
  null
  
)

export default component.exports